import React, { useState, useEffect } from 'react';
import { sharedListsAPI } from '../services/api';
import './TripsTab.css';

const shareUrl = (token) => `${window.location.origin}/list/${token}`;

// Manage public trip checklists that friends can edit without logging in
function TripsTab() {
  const [lists, setLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');
  const [copiedId, setCopiedId] = useState(null);

  const loadLists = async () => {
    try {
      const response = await sharedListsAPI.getAll();
      setLists(response.data);
    } catch (error) {
      console.error('Error loading shared lists:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLists();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    try {
      const response = await sharedListsAPI.create({ title: title.trim() });
      setLists((prev) => [response.data, ...prev]);
      setTitle('');
    } catch (error) {
      alert(error.response?.data?.detail || 'Could not create list');
    }
  };

  const handleCopy = async (list) => {
    const url = shareUrl(list.token);
    try {
      if (navigator.share) {
        await navigator.share({ title: list.title, url });
        return;
      }
      await navigator.clipboard.writeText(url);
      setCopiedId(list.id);
      setTimeout(() => setCopiedId(null), 2000);
    } catch (error) {
      if (error.name !== 'AbortError') window.prompt('Copy this link:', url);
    }
  };

  const handleDelete = async (list) => {
    if (!window.confirm(`Delete "${list.title}"? The link will stop working for everyone.`)) return;
    try {
      await sharedListsAPI.delete(list.id);
      setLists((prev) => prev.filter((l) => l.id !== list.id));
    } catch (error) {
      alert('Could not delete list');
    }
  };

  return (
    <div className="trips-tab">
      <div className="trips-header">
        <h2>🧳 Trip lists</h2>
        <p>Shared grocery checklists. Anyone with the link can add items and pick who buys what, no login needed.</p>
      </div>

      <form className="trips-create" onSubmit={handleCreate}>
        <input
          type="text"
          value={title}
          maxLength={200}
          placeholder="e.g. Airbnb Annecy – August"
          onChange={(e) => setTitle(e.target.value)}
        />
        <button type="submit" disabled={!title.trim()}>Create list</button>
      </form>

      {loading ? (
        <p className="trips-empty">Loading...</p>
      ) : lists.length === 0 ? (
        <p className="trips-empty">No trip lists yet.</p>
      ) : (
        <ul className="trips-list">
          {lists.map((list) => (
            <li key={list.id}>
              <div className="trips-info">
                <a href={`/list/${list.token}`} target="_blank" rel="noopener noreferrer">
                  {list.title}
                </a>
                <span>
                  {list.done_count}/{list.item_count} bought
                </span>
              </div>
              <div className="trips-actions">
                <button type="button" onClick={() => handleCopy(list)}>
                  {copiedId === list.id ? '✓ Copied' : '🔗 Share link'}
                </button>
                <button type="button" className="trips-delete" onClick={() => handleDelete(list)}>
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default TripsTab;
